"use client";
import { EmailInput } from "@/components/shared/ui/email-input";
import { Label } from "@/components/shared/ui/label";
import { Skeleton } from "@/components/shared/ui/skeleton";
import { Textarea } from "@/components/shared/ui/text-area";
import { ShopEmailContact, ShopEmailContactList } from "@/lib/checkout/checkout-types";

interface EmailSectionProps {
    contacts: ShopEmailContactList[];
    selectedContacts: ShopEmailContact[];
    emailNote: string;
    loading?: boolean;
    onContactsChange?: (contacts: ShopEmailContact[]) => void;
    onEmailNoteChange?: (note: string) => void;
}

export default function EmailSection({
    contacts,
    selectedContacts,
    emailNote,
    loading = false,
    onContactsChange,
    onEmailNoteChange
}: EmailSectionProps) {
    return (
        <>
            <div className="grid gap-2">
                <Label htmlFor="contacts" className="text-left">
                    Select Contacts
                </Label>
                {loading ? (
                    <Skeleton className="h-10 w-full" />
                ) : (
                    <EmailInput
                        defaultValue={selectedContacts}
                        contactGroups={contacts}
                        onEmailsChange={onContactsChange || (() => {})}
                        disabled={loading}
                    />
                )}
            </div>

            <div className="grid gap-2">
                <Label htmlFor="note" className="text-left">
                    Email Note
                </Label>
                {loading ? (
                    <Skeleton className="h-20 w-full" />
                ) : (
                    <Textarea
                        id="note"
                        value={emailNote}
                        onChange={(e) => onEmailNoteChange?.(e.target.value)}
                        placeholder="Add a message to include in the email..."
                        className="col-span-3"
                        disabled={loading}
                    />
                )}
            </div>
        </>
    );
}
